import {
    COST_CENTERS,
    PARENT_COST_CENTERS,
    CHILD_COST_CENTERS,
    CHILD_COST_CENTERS_MULTI,
    GET_CERTIFIED_JOB_CC,
    GET_COST_CENTERS,
    COST_CENTER_LEVELS
} from "../../types";

const initialState = {};
const CostCenterReducer = (state = initialState, action) => {
    let ccAction = [
        COST_CENTERS,
        PARENT_COST_CENTERS,
        CHILD_COST_CENTERS,
        CHILD_COST_CENTERS_MULTI,
        GET_CERTIFIED_JOB_CC,
        GET_COST_CENTERS,
        COST_CENTER_LEVELS].find(at => at === action.type);
    if (ccAction) {
        return { ...state, [action.type]: action.payload };
    };
    return state;
}

export default CostCenterReducer;